import React, {forwardRef} from "react";
import style from './pickerButton.module.css'
export const CustomDateButton = forwardRef(({ value, onClick, startDate, endDate }, ref) => (
    <div onClick={onClick} ref={ref} className={style.button}>
        {startDate && endDate ? `${startDate} - ${endDate}` : value}
    </div>
));
